import { Component, HostBinding, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
	selector: 'copo-loading-spinner-cell',
	templateUrl: './loading-spinner-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
})
export class LoadingSpinnerCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.loading-spinner-cell-container') @Input() container = true;
	@HostBinding('attr.role') role = 'progressbar';
	@HostBinding('attr.aria-valuemin') min = 0;
	@HostBinding('attr.aria-valuemax') max = 100;
	@HostBinding('title') title = 'Loading cell content...';

	agInit(_params: ICellRendererParams<unknown, unknown>) {
		// noop
	}

	refresh() {
		return false;
	}
}
